import React, { useEffect, useRef, useState } from 'react';
import { CustomCheckbox, CustomButton, Footer } from 'src/app/components/commonComponents';
import LocalImages from '../../static';
import { useAppDispatch } from "../../services/store";
import { LoginPersistActions } from "src/shared/redux-state/src/lib/login/LoginSlice";
import { acceptTnC } from "src/shared/services/src";
import { AxiosError } from 'axios';
import { toast } from "react-toastify";
import { APP_MESSAGES, EXTERNAL_URL } from "src/shared/config/src";
import { getRedirectionRoute } from 'src/app/utilities/helpers';
import { useNavigate } from 'react-router-dom';

const TermsAndConditionsScreen = () => {
  const buttonRef: any = useRef(null);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isAccepting, setIsAccepting] = useState<boolean>(false);
  const [accepted, setAccepted] = useState(false);
  const [redirectionRoute, setRedirectionRoute] = useState<string>();

  useEffect(() => {
    const redirectTo = getRedirectionRoute();
    if (redirectTo) {
        setRedirectionRoute(redirectTo);
    }
  }, [])

  const handleTnCAccept = async () => {
    if (isAccepting) return;

    if (!accepted) {
      toast.error('Please tick the above box to proceed.', { autoClose: 5000 });
      return;
    }

    try {
      setIsAccepting(true);
      const response = await acceptTnC();
      if (response && Object.keys(response).length > 0) {
        await dispatch(LoginPersistActions.setTermsAccepted(true));
        if(redirectionRoute) navigate(redirectionRoute);
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const apiError = error as AxiosError;
        console.log("error  : ", error.response);
        if (apiError && apiError.response) {
          const { errors } = error.response?.data;
          toast.error(errors.join(", "), { autoClose: 5000 });
        } else {
          toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
        }
      }
    } finally {
      setIsAccepting(false);
    }
  }

  const handleCheckbox = (event: any) => {
    setAccepted(event.target.checked);
  }

  const inputLabel = () => {
    return (
      <>
        I have read the
        <a href={EXTERNAL_URL.TnC} className='text-info text-decoration-none' target='_blank' rel='noreferrer'> Terms and Condition</a>,
        <a href={EXTERNAL_URL.PRIVACY_POLICY} className='text-info text-decoration-none' target='_blank' rel='noreferrer'> Privacy Policy</a> and
        <a href={EXTERNAL_URL.GDPR} className='text-info text-decoration-none' target='_blank' rel='noreferrer'> GDPR Notice</a>
      </>
    )
  }

  return (
    <div className='main-wrapper bg-white container'>
      <div className='d-flex flex-column flex-grow-1 mg-b-20'>
        <div className='mg-b-78 mg-t-xxl-100 mg-t-xs-50 pd-t-md-30 pd-t-xs-0 d-flex justify-content-center align-items-center'>
          <img src={LocalImages.logo} alt="logo" className="eyworks-logo"/>
        </div>
        <div className='mg-b-30'>
          <CustomCheckbox label={inputLabel()} isClickWidthOutLabel={true} onChange={handleCheckbox} />
        </div>
        <p className='fs-12 text-gray-300 mg-b-35'>Our Terms and Conditions and Privacy Policy have recently been updated. By ticking the box above and clicking 'Accept' you are agreeing to our updated terms.</p>
        <CustomButton buttonRef={buttonRef} text='Accept' onClick={handleTnCAccept} color='primary' />
      </div>
      <Footer showFooterLinks={false} />
    </div>
  );
};

export default TermsAndConditionsScreen;
